<div class="row mfa-section">
  <div class="col-4 link">
    <img [src]="qrCodeImage"  alt="QR Code" class="img-fluid" />
    <div class="mx-auto col-12">
      <span translate>
         <a (click)="showMicrosoftAuthenticatorInfo()" target="_blank" translate> Login.MFA.QR Link </a>
        Login.MFA.QR Information
      </span>
    </div>
    <div class="mx-auto col-8">
      <p-button severity="primary" class="mt-2" icon="pi pi-undo" label="{{ 'Login.MFA.Back' | translate }}" id="login-loginBackButton" (click)="toggleShowMFAInformation(false)"> </p-button>
    </div>
  </div>
  <div class="col-8 text-left information">
    <label class="mb-3">
      <span translate> Login.MFA.Information </span>
    </label>
    <section class="mb-5">
      <ul>
        <li> <span translate> Login.MFA.Install </span> </li>
        <li> <span translate> Login.MFA.Create Account </span> </li>
        <li> <span translate> Login.MFA.Scan </span> </li>
        <li> <span translate> Login.MFA.Enter Code </span> </li>
      </ul>
      <div class="row">
        <div class="offset-1 col-11">
          <span> <b translate> Login.MFA.Code </b> : </span>
          <span> {{ code }} </span>
        </div>
      </div>
    </section>
    <label class="mb-3 mt-2">
      <span translate> Login.MFA.After Steps </span>
    </label>
  </div>
</div>
